/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getUnitsOfMeasure,
    getUnitOfMeasure,
    printUnitOfMeasure,
    createUnitsOfMeasure,
    updateUnitsOfMeasure,
    deleteUnitsOfMeasure,
} from "Core/configuration/units_of_measure/config/api.units_of_measure";

const state = {
    page: {},
    form: {},
    units_of_measure: [],
    unit_of_measure_options: [],
    selectedUnitOfMeasure: {
        id: null,
        company_id: "",
        unit_of_measure_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        unit_of_measure_details: [],
    },
    units_of_measure_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_units_of_measure: {
        id: {
            name: "id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        unit: {
            name: "unit",
            rules: "trim|max_length[65]|required",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        unit_abbrev: {
            name: "unit_abbrev",
            rules: "trim|max_length[3]|required",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    units_of_measure: (state) => {
        return state.units_of_measure;
    },
};

// actions
const actions = {
    async fetchUnitsOfMeasure({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getUnitsOfMeasure({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "unit_of_measure_options",
                        with: response.data.units_of_measure,
                    });
                } else {
                    commit("mutate", {
                        property: "units_of_measure",
                        with: response.data.units_of_measure,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchUnitOfMeasure({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getUnitOfMeasure(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedUnitOfMeasure",
                    with: response.data.unit_of_measure,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printUnitOfMeasure({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printUnitOfMeasure(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveUnitOfMeasure({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["id"] === "undefined" || body["id"] == null || body["id"] == "") {
                delete body["id"];
                response = await createUnitsOfMeasure({ body: body, headers: config.headers });
            } else {
                let id = body["id"];
                delete body["id"];
                response = await updateUnitsOfMeasure({ body: body, headers: config.headers }, id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteUnitOfMeasure({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteUnitsOfMeasure(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
    resetUnitsOfMeasure(state) {
        state.page = {};
        state.form = {};
        state.units_of_measure = [];
        state.unit_of_measure_options = [];
        state.selectedUnitOfMeasure = {
            id: null,
            company_id: "",
            unit_of_measure_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            unit_of_measure_details: [],
        };
        state.units_of_measure_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
